export const api_version = 1;
export const app_version = '1.14';
export const build = '2025.04.15.11.30';
export const dev_env = false;

export const aft_server = dev_env ? 'http://aft.local.192.168.4.40.nip.io' : 'https://aftplatform.com';
export const server = dev_env ? 'http://homesafealerts.local.192.168.4.40.nip.io' : 'https://homesafealerts.com';

export default {
    aft: {
        api_url: `${aft_server}/api/v2/`,
        server: aft_server
    },
    app_version: app_version,
    build: build,
    dev_env: dev_env,
    version: api_version,
    server: server,
    stripe: 'pk_live_51IXdy9G6RZW42dLLNWUYUavOUd7i4I8XmTwO819lk1cvXHLsQYPEz8nPQHqa0FE9HFiEWLJeP8PRyGtYpRgwaN5g00YlzPewN3',
    url: `${server}/api/v${api_version}`
}
